var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter_Logo_Blue"),React.createElement("path",{"d":"M153.6,301.6c94.3,0,145.9-78.2,145.9-145.9c0-2.2,0-4.4-0.1-6.6c10-7.3,18.7-16.3,25.6-26.5\n\tc-9.4,4.1-19.3,6.9-29.5,8.1c10.7-6.4,18.7-16.5,22.5-28.4c-10.1,6-21.1,10.2-32.6,12.4c-19.4-20.7-51.9-21.7-72.6-2.2\n\tc-13.3,12.5-19,31.2-14.8,49c-41.2-2.1-79.7-21.5-105.7-53.6c-13.6,23.4-6.7,53.4,15.9,68.5c-8.2-0.2-16.1-2.4-23.3-6.4\n\tc0,0.2,0,0.4,0,0.6c0,24.4,17.2,45.4,41.2,50.3c-7.6,2.1-15.5,2.4-23.2,0.9c6.7,20.9,26,35.2,47.9,35.6c-18.2,14.3-40.6,22-63.7,22\n\tc-4.1,0-8.2-0.3-12.2-0.7C98.5,293.6,125.7,301.6,153.6,301.6","key":1})]);
}

TwitterInline.defaultProps = {"version":"1.1","id":"Logo_FIXED","x":"0px","y":"0px","viewBox":"0 0 400 400","enableBackground":"new 0 0 400 400","xmlSpace":"preserve"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
